// src/pages/OwnerLogin.jsx
import { useState } from "react";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

export default function OwnerLogin() {
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      if (mode === "login") {
        await signInWithEmailAndPassword(auth, email, password);
      } else {
        await createUserWithEmailAndPassword(auth, email, password);
      }
      navigate("/dashboard");
    } catch (err) {
      setError(err.message.replace("Firebase: ", "").replace(/\(auth.*\)/, ""));
    }
    setLoading(false);
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>🐱</div>
        <h1 style={styles.title}>{mode === "login" ? "Owner Login" : "Create Account"}</h1>
        <p style={styles.sub}>Manage your cat listings and adoption requests</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div>
            <label style={styles.label}>Email</label>
            <input type="email" value={email} onChange={e=>setEmail(e.target.value)}
              placeholder="your@email.com" required style={styles.input}/>
          </div>
          <div>
            <label style={styles.label}>Password</label>
            <input type="password" value={password} onChange={e=>setPassword(e.target.value)}
              placeholder="••••••••" required style={styles.input}/>
          </div>
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" disabled={loading} className="btn-primary" style={{width:"100%",justifyContent:"center",padding:14,fontSize:16}}>
            {loading ? <div className="spinner" style={{width:18,height:18,margin:"0 auto"}}/> : mode === "login" ? "Login" : "Create Account"}
          </button>
        </form>

        <p style={styles.switchText}>
          {mode === "login" ? "New owner? " : "Already have an account? "}
          <button onClick={()=>setMode(mode==="login"?"register":"login")} style={styles.switchBtn}>
            {mode === "login" ? "Create account" : "Login"}
          </button>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", padding:24 },
  card: { background:"#fff", borderRadius:24, padding:"48px 40px", width:"100%", maxWidth:420, boxShadow:"var(--shadow-l)", textAlign:"center" },
  logo: { fontSize:48, marginBottom:16 },
  title: { fontFamily:"'Playfair Display',serif", fontSize:32, color:"var(--deep)", marginBottom:8 },
  sub: { color:"var(--muted)", fontSize:15, marginBottom:28 },
  form: { display:"flex", flexDirection:"column", gap:16, textAlign:"left" },
  label: { display:"block", fontSize:13, fontWeight:600, color:"var(--mid)", marginBottom:6 },
  input: { width:"100%", border:"1.5px solid var(--peach)", borderRadius:10, padding:"12px 14px", fontSize:15, color:"var(--text)", background:"#fff", outline:"none", fontFamily:"'Outfit',sans-serif" },
  error: { color:"var(--danger)", fontSize:14, textAlign:"center" },
  switchText: { marginTop:20, fontSize:14, color:"var(--muted)" },
  switchBtn: { background:"none", border:"none", color:"var(--rust)", cursor:"pointer", fontSize:14, fontWeight:600 },
};
